interface SectionHeadingProps {
  index: string;
  kicker: string;
  title: string;
  desc: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ index, kicker, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'}>
      <div className={`flex items-center gap-3 ${isCenter ? 'justify-center' : ''}`}>
        <span className="font-heading text-sm font-black text-accent-600">{index}</span>
        <span className="h-px w-8 bg-foreground-300" />
        <span className="text-xs font-semibold tracking-[0.24em] text-primary-600">{kicker}</span>
      </div>
      <h2 className="mt-4 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-4xl">
        {title}
      </h2>
      <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
    </div>
  );
}